import { loadStripe } from '@stripe/stripe-js';

// Stripe configuration
export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '');

// Plan names, prices and features live in the subscription_plans table (see lib/plans.ts).
// A plan id is subscriptions.plan_id; legacy ids (standard/premium/enterprise) are still valid.
export type PlanId = string;

// Helper to check subscription status.
// Accepts either the old config_object.subscription shape or the new subscriptions row shape.
export const checkSubscriptionStatus = (sub: any): {
  isActive: boolean;
  planId?: string;
  expiresAt?: string;
} => {
  if (!sub) return { isActive: false };

  const planId = sub.planId || sub.plan_id;
  const status = sub.status;
  const currentPeriodEnd = sub.currentPeriodEnd || sub.current_period_end;

  const now = new Date();
  const exp = currentPeriodEnd ? new Date(currentPeriodEnd) : null;

  // A subscription is active if:
  // 1. Status is 'active' (paid subscription)
  // 2. Status is 'trialing' and trial hasn't expired yet
  const isActive: boolean =
    (status === 'active' && (!exp || exp > now)) ||
    (status === 'trialing' && exp && exp > now) ||
    false;

  return {
    isActive,
    planId,
    expiresAt: currentPeriodEnd || sub.expiresAt || undefined,
  };
};
